import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalconfig';

let instance;

export function getMsalInstance() {
    if (!instance) instance = new PublicClientApplication(msalConfig);
    return instance;
}
